module.exports = {
    headers: {
        accept: 'application/json'
    },
    //baseUrl: 'http://localhost:37429/api/'
    //baseUrl: 'https://monitoramento.consorcioprosinos.com.br/api/'
    baseUrl: 'https://monitoramento.prosinos.rs.gov.br/api/'
}
